
// Environment configuration for API endpoints
export const SUPABASE_URL = "https://swhwykzorcbiutczhjgn.supabase.co";
export const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InN3aHd5a3pvcmNiaXV0Y3poamduIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzgyMjI2NzksImV4cCI6MjA1Mzc5ODY3OX0.UwpU4AwW_PFuck666iRg8-MSU7jTzJJ-LXZLLTobTk0";

// Function edge API endpoint base
export const API_ENDPOINT = `${SUPABASE_URL}/functions/v1`;

// Authorization header with anonymous key
export const getAuthHeader = () => ({
  'Content-Type': 'application/json',
  'Authorization': `Bearer ${SUPABASE_ANON_KEY}`
});
